import SMBG from './SMBG';
import MainAccordion from 'components/Accordion/MainAccordion';
import {digitsEnToFa} from "persian-tools2";

const SmbgWrapper = ({selectedRangeData, daysAgo}) => {
  return (


    <MainAccordion header={` خلاصه ای از میزان تست شما در ${digitsEnToFa(daysAgo)} روز`} open={'panel1'}>
      <SMBG
        daysWithTest={selectedRangeData?.daysWithTest}
        testsPerDay={selectedRangeData?.testsPerDay}
        totalRecordCount={selectedRangeData?.totalRecordCount}
        lastTestDate={selectedRangeData?.lastTestDate}
      />
    </MainAccordion>
  );
};

export default SmbgWrapper;
